const MarketplaceVouchersRoutes = {
  getAllVouchers: "/vouchers/marketplace/",
  createVoucher: "/vouchers/marketplace/create",
  updateVoucher: "/vouchers/marketplace/update",
  deleteVoucher: "/vouchers/marketplace/delete",
  applyVoucher: "/vouchers/marketplace/apply",
};

export default MarketplaceVouchersRoutes;
